import { render, staticRenderFns } from "./LatestProduct.vue?vue&type=template&id=23610171"
import script from "./LatestProduct.vue?vue&type=script&lang=js"
export * from "./LatestProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports